<template>
  <div class="warp">
    <div class="top">
      <div class="title">
        <el-input
          style="width: 260px"
          v-model="searchText"
          placeholder="输入关键词，搜索表格内容"
        ></el-input>
        <el-button
          style="margin-left: 10px"
          type="primary"
          class="primary"
          @click="query"
          >查询</el-button
        >
        <el-button
          style="margin-left: 10px"
          type="primary"
          class="primary"
          @click="addRow"
          >新增</el-button
        >
      </div>
    </div>
    <div class="bottom dn-content-bg">
      <nk-table
        id="table"
        height="100%"
        :data="tableData"
        :noDataTitle="'暂无数据1'"
        :columns="columns"
        :showPage="true"
        :page="page"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <el-table-column
          slot="operation"
          label="操作"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              class="table-btn"
              @click="editRow(scope.row, scope.$index)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </nk-table>
    </div>
    <!-- 编辑弹窗开始 -->
    <edit-measure
      :dialog.sync="dialog"
      v-if="dialog.showEdit"
      :selectedMeasure="selectedMeasure"
      :nodeData="nodeData"
      :viewId="viewId"
    ></edit-measure>
    <!-- 编辑弹窗结束 -->
    <!-- 新增弹窗开始 -->
    <el-dialog
      title="添加节点"
      :visible.sync="visibleItem"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="objectItem"
        style="text-align: left"
        label-width="80px"
      >
        <!-- <el-form-item label="计量点ID" prop="measureId">
            <el-input
              placeholder="前版本计量点ID"
              v-model="objectItem.measureId"
            ></el-input>
          </el-form-item> -->
        <el-form-item label="显示名称" prop="measureName">
          <el-input v-model="objectItem.measureName"></el-input>
        </el-form-item>
        <el-form-item label="模板" prop="measureTemplateId">
          <label v-if="objectItem.templateObj">{{
            objectItem.templateObj.displayName
          }}</label>
          <el-button style="margin-left: 10px" @click="showTemplate" type="text"
            >选择模板</el-button
          >
        </el-form-item>
        <el-form-item label="挂载架构" prop="measureMountedOn">
          <label v-if="objectItem.measureMountedOnObj">{{
            objectItem.measureMountedOnObj.name
          }}</label>
          <el-button style="margin-left: 10px" @click="showORG" type="text"
            >选择部门</el-button
          >
        </el-form-item>
        <!-- <el-form-item label="排序编号" prop="measureRemark">
            <el-input-number v-model="objectItem.orderNum"></el-input-number>
          </el-form-item> -->
        <el-form-item label="备注" prop="measureRemark">
          <el-input v-model="objectItem.measureRemark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveItemInTemplate">确 定</el-button>
        <el-button @click="visibleItem = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗结束 -->
    <!-- 组织架构 -->
    <div>
      <el-dialog
        title="选择组织架构"
        :visible.sync="visibleOrg"
        width="500px"
        :close-on-click-modal="false"
      >
        <div>
          <el-tree
            class="filter-tree"
            :data="orgTreeData"
            :props="defaultOrgProps"
            node-key="id"
            default-expand-all
            @node-click="orgNodeClick"
            :highlight-current="true"
          >
            <span class="span-ellipsis" slot-scope="{ node, data }">
              <span :node="node" :title="data.name">{{ data.name }}</span>
            </span>
          </el-tree>
        </div>
      </el-dialog>
    </div>
    <!-- 组织架构 -->
    <!-- 模板选择 -->
    <div>
      <el-dialog
        title="选择模板"
        :visible.sync="visibleTemperature"
        width="500px"
        :close-on-click-modal="false"
        style="text-align: left"
      >
        <div>
          <el-tree
            class="filter-tree"
            :data="treeTemplateData"
            node-key="id"
            default-expand-all
            @node-click="templateNodeClick"
            :highlight-current="true"
          >
            <span class="span-ellipsis" slot-scope="{ node, data }">
              <span :node="node" :title="data.displayName">{{
                data.displayName
              }}</span>
            </span>
          </el-tree>
        </div>
      </el-dialog>
    </div>
    <!-- 模板選擇 -->
  </div>
</template>

<script>
import api from "@common/api/index.js";
import uuid from "uuid/v1";
import NkTable from "@/components/common/NkTable";
import editMeasure from "./editMeasure";
import * as utils from "@/utils/index.js";
import { toPage } from "@/utils/index.js";
import tree from "@/utils/tree.js";
import { findDataByParam } from "@/utils/index.js";
export default {
  components: { NkTable, editMeasure },
  data() {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入名称"));
      }
    };
    return {
      tableData: [],
      equipments: null,
      equipmentData: [],
      columns: [],
      enumData: [],
      searchText: "",
      enumClass: "",
      page: {
        pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
        size: 10,
        total: 0,
        pageIndex: 1,
      },
      dialog: {
        title: "编辑", //弹窗标题
        showEdit: false, //弹窗显示状态
      },
      visibleItem: false,
      objectItem: {},
      objItem: {},
      visibleOrg: false,
      orgTreeData: [],
      defaultOrgProps: {
        children: "children",
        label: "name",
      },
      rules: {
        measureName: [
          { validator: checkName, trigger: ["blur", "change"], required: true },
        ],
      },
      selectedMeasure: {
        measureTemplateId: "100",
        measureId: "7047287449720854",
        measureCompanyId: 0,
      },
      viewId: "",
      templateId: "",
      nodeData: "",
      visibleTemperature: false,
      treeTemplateData: [],
      tableData1: [],
    };
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {
    let vm = this;
    vm.$eventBus.$on("changeCompanyId", (companyId) => {
      vm.init();
    });
  },
  created() {
    this.init();
    this.getCompanyViewTreesInfo();
  },
  methods: {
    init() {
      let vm = this;
      vm.$api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(
          vm.$store.state.user.currentCompanyId,
          "/nygl/equipment/equipment1",
          null
        )
        .then((res) => {
          const enumClass = findDataByParam("enumClass", false, res.data);
          res.data.forEach((item) => {
            if (item.param == "viewId") {
              vm.viewId = item.value;
            }
          });
          vm.enumClass = enumClass;
          vm.getData();
        });
    },
    //获取数据
    async getData() {
      let vm = this;
      //获取枚举
      let resClass2 = await vm.$api.enumClass.getSubEnumClasses2(
        vm.enumClass,
        1,
        vm.$store.state.user.currentCompanyId
      );

      // 查询电表类设备
      vm.equipments = resClass2.data.find(
        (item) => item.name === "__electricityMeter"
      );

      let resAllEnum = await vm.$api.enumClass.getSubEnumClasses2(
        "",
        0,
        vm.$store.state.user.currentCompanyId
      );
      vm.equipmentData = resAllEnum.data;
      vm.query();
    },
    /*  */
    //查询
    async query() {
      this.getTable(1);
    },
    /* 获取表格数据数据 */
    async getTable(pageIndex) {
      let vm = this;
      //根据枚举查询计量点
      let resClasses = await vm.$api.enumClass.getMeasuresFromEnumClasses(
        [vm.equipments.id],
        vm.$store.state.user.currentCompanyId
      );

      let resProperties2 = { data: null };
      if (resClasses.data[0].measureList.length > 0) {
        let ids = [];
        for (let i = 0; i < resClasses.data[0].measureList.length; i++) {
          const element = resClasses.data[0].measureList[i];
          ids.push(element.id);
        }
        //查计量点参数信息
        resProperties2 = await vm.$api.measure.getMeasuresProperties2(
          JSON.stringify(ids)
        );
        let coulum = {};
        let tableData = [];
        for (let i = 0; i < resProperties2.data.length; i++) {
          const propertyGroups = resProperties2.data[i].propertyGroups;
          //每个计量点的参数对象
          let item = {
            templateId: resClasses.data[0].measureList.find(
              (c) => c.id == resProperties2.data[i].id
            ).templateId,
            measureId: resProperties2.data[i].id,
            measureName: resClasses.data[0].measureList.find(
              (c) => c.id == resProperties2.data[i].id
            ).name,
          };
          for (let j = 0; j < propertyGroups.length; j++) {
            if (propertyGroups[j].name.indexOf("BasicInformation") > -1) {
              for (let k = 0; k < propertyGroups[j].properties.length; k++) {
                let property = propertyGroups[j].properties[k];
                //判断生成colums格式
                if (!coulum.hasOwnProperty(property.name)) {
                  coulum[property.name] = property.displayName;
                }
                item[property.name] = property.value;

                if (property.regulation.valueType == 5) {
                  let label = "-";
                  if (property.value !== "") {
                    const enumObj = vm.equipmentData.find(
                      (c) => c.name === property.value
                    );
                    label = enumObj ? enumObj.displayName : property.value;
                  }
                  item[property.name] = label;
                }
              }
            }
          }
          tableData.push(item);
        }
        let columns = [
          {
            prop: "measureName",
            label: "计量点名称",
            show: true,
          },
        ];
        for (let key in coulum) {
          columns.push({
            prop: key,
            label: coulum[key],
            show: true,
          });
        }
        console.log(columns);
        columns.push({
          prop: "operation",
          slot: "operation",
          label: "操作",
          show: true,
        });
        vm.columns = columns;
        let searchData = [];
        if (vm.searchText.length == 0) {
          searchData = tableData;
        } else {
          for (let i = 0; i < tableData.length; i++) {
            let suo = false;
            let obj = tableData[i];
            for (let key in obj) {
              if (obj[key].indexOf(vm.searchText) > -1) {
                suo = true;
                break;
              }
            }

            if (suo) {
              searchData.push(obj);
            }
          }
        }
        let datas = toPage(searchData, pageIndex, vm.page.size);
        vm.page.pageIndex = pageIndex;
        vm.page.total = datas.total;
        vm.tableData = datas.arr;
        console.log(vm.columns);
        console.log(vm.tableData);
      } else {
        console.log(1);
        vm.columns = [];
        vm.tableData = [];
      }
    },
    /* 表格编辑 */
    editRow(row, i) {
      console.log(row);
      (this.selectedMeasure = {
        measureTemplateId: row.templateId,
        measureId: row.measureId,
        measureCompanyId: 0,
      }),
        (this.dialog.showEdit = true);
    },
    /* 新增 */
    addRow() {
      let vm = this;
      vm.objectItem = {
        viewId: "",
        parentId: 0,
        measureName: "",
        measureRemark: "",
        measureTemplateId: "",
        measureSalespersonId: 0,
        measureMountedOn: "",
        orderNum: 0,
        measureMountedOnObj: null,
      };
      vm.visibleItem = true;
    },
    /* 选择部门 */
    showORG() {
      let vm = this;
      vm.visibleOrg = true;
      vm.orgLoading = true;
      vm.$api.orgStructNode
        .getORGStructNodes(this.$store.state.user.info.companyId)
        .then((res) => {
          let data = res.data;
          vm.orgTreeData = tree.creatTreeJson(data, 0);
          vm.orgLoading = false;
        });
    },
    /* 组织结构点击 */
    orgNodeClick(data) {
      let vm = this;
      vm.objectItem.measureMountedOn = data.id;
      vm.objectItem.measureMountedOnObj = data;
      vm.visibleOrg = false;
    },
    /* 新增保存 */
    saveItemInTemplate() {
      let vm = this;
      if (vm.objectItem.measureId) {
        api.measure
          .createMeasure(
            vm.objectItem.measureId,
            vm.objectItem.measureName,
            vm.objectItem.measureRemark,
            vm.objectItem.measureTemplateId,
            vm.objectItem.measureSalespersonId,
            vm.objectItem.measureMountedOn
          )
          .then((res) => {
            if (res.success) {
              api.view
                .addViewNode(
                  vm.viewId,
                  vm.objectItem.parentId,
                  vm.objectItem.measureId,
                  vm.objectItem.orderNum
                )
                .then((obj) => {
                  vm.$message("添加成功！");
                  vm.getTable(1);
                  vm.visibleItem = false;
                });
            } else {
              vm.$message.error(res.msg);
            }
          });
      } else {
        api.view
          .addViewNode3(
            vm.viewId,
            vm.objectItem.parentId,
            vm.objectItem.measureName,
            vm.objectItem.measureRemark,
            vm.objectItem.measureTemplateId,
            vm.objectItem.measureSalespersonId,
            vm.objectItem.measureMountedOn,
            vm.objectItem.orderNum
          )
          .then((res) => {
            if (res.success) {
              vm.$message("添加成功！");
              vm.getTable(1);
              vm.visibleItem = false;
            } else {
              vm.$message.error(res.msg);
            }
          });
      }
    },
    /* 页码改变 */
    handleCurrentChange(val) {
      this.getTable(val);
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTable(1);
    },
    /* 模板选择 */
    showTemplate() {
      let vm = this;
      Promise.all([
        api.measure.getMeasureTemplateGroups(),
        api.measure.getMeasureTemplates(),
      ]).then((resArr) => {
        let groups = resArr[0].data;
        let templates = resArr[1].data;
        let groupTreeData = tree.creatTreeJson(groups, 0);
        //获取底下包含的所有分组
        let arr = [];
        console.log(vm.objItem);
        console.log(vm.objItem.measureTemplateGroupRestriction);
        for (
          let index = 0;
          index < vm.objItem.measureTemplateGroupRestriction.length;
          index++
        ) {
          let data = vm.getTmpIds(
            vm.breadthQuery(
              groupTreeData,
              vm.objItem.measureTemplateGroupRestriction[index].id
            )
          );
          arr = arr.concat(data);
          console.log(arr);
        }
        //合并模板组和模板

        for (let i = 0; i < templates.length; i++) {
          templates[i].isTemplate = true;
          for (let j = 0; j < groups.length; j++) {
            let groupId = arr.find((obj) => obj === groups[j].id);
            if (groupId) {
              if (groups[j].id === templates[i].groupId) {
                templates[i].templateId = templates[i].id;
                templates[i].id = uuid();
                templates[i].parentId = groups[j].id;
                groups.push(templates[i]);
              }
            }
          }
        }

        let groupTree = tree.creatTreeJson(groups, 0);
        vm.treeTemplateData = groupTree;
        console.log(groupTree);
        vm.visibleTemperature = true;
      });
    },
    /* 模板树点击 */
    templateNodeClick(node) {
      let vm = this;
      if (node.isTemplate) {
        vm.objectItem.templateObj = node;
        vm.objectItem.measureTemplateId = node.templateId;
        vm.visibleTemperature = false;
      }
    },
    /* 获取视图组 */
    getCompanyViewTreesInfo() {
      let vm = this;
      api.view
        .getCompanyViewTreesInfo(vm.$store.state.user.currentCompanyId)
        .then((res) => {
          if (res) {
            vm.tableData1 = res.data;
            if (vm.viewId) {
              vm.getViewTreeNodes(vm.viewId);
            }
          }
        });
    },
    /* 获取节点数据 */
    getViewTreeNodes(id) {
      api.view.getViewTreeNodes(id).then((res) => {
        console.log(this.tableData1);
        console.log(this.tableData1);
        let item = this.tableData1.find((obj) => obj.id === id);
        let templates = [];
        api.measure.getMeasureTemplates().then((obj) => {
          templates = obj.data;
        });
        console.log(item);
        item.templates = templates;

        this.objItem = item;
        let nodeData = [
          {
            id: 0,
            measureName: item ? item.displayName : "对象",
          },
        ];
        nodeData = nodeData.concat(res.data);
        this.nodeData = nodeData;
      });
    },
    breadthQuery(tree, id) {
      var stark = [];
      stark = stark.concat(tree);
      while (stark.length) {
        var temp = stark.shift();
        if (temp.children) {
          stark = stark.concat(temp.children);
        }
        if (temp.id === id) {
          return temp;
        }
      }
    },
    /* 获取模板id */
    getTmpIds(tree) {
      var stark = [];
      let arr = [];
      stark = stark.concat(tree);

      while (stark.length) {
        var temp = stark.shift();
        if (temp.children) {
          stark = stark.concat(temp.children);
        }
        arr.push(temp.id);
      }
      return arr;
    },
  },
};
</script>
<style lang="scss" scoped>
.warp {
  padding: 14px;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  height: 100%;
}
.bottom {
  flex: 1;
  overflow: auto;
  margin-top: 14px;
}
.title {
  width: 100%;
  padding: 14px;
  border-bottom: 1px solid #ccc;
  box-sizing: border-box;
  display: flex;
  color: #000;
  align-items: center;
  background: #fff;
}
.sb {
  margin-right: 10px;
}

.primary >>> .el-button--primary {
  background-color: #0080ff;
  background: #0080ff;
  border-color: #0080ff;
}
::v-deep .el-button--primary {
  background-color: #0080ff;
  background: #0080ff;
  border-color: #0080ff;
}

.table-btn {
  color: #0080ff;
}
</style>
